import * as React from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, Table, UncontrolledDropdown} from 'reactstrap';
import SettingsIcon from 'mdi-react/SettingsIcon';
import Paginacion from '../../../common/paginacion/paginacion';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import {reset} from 'redux-form';
import GeoModal from '../clientes/geo-modal';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {Store} from 'react-redux';
import VisicoolerNuevoModal from './visicooler-nuevo-modal';
import {error, success} from '../../../../utils/notification-actions';
import {VisicoolerModeloEstado} from '../../../../utils/constants';
import MiranaState from '../../../../reduxstore/mirana-state';

interface IProps {
    keyword: string;
    data?: mirana.BuscarVisicoolersResponse;
    handlePagination: (page: number) => void;
    actualizarData: (data: mirana.BuscarVisicoolersResponse) => void;
    fuerzaVentaId: string;
}

interface IState {
    modelosResponse?: mirana.IVisicoolerModelo[];
    openGeoModal: boolean;
    modalOpen: boolean;
    selectedCliente?: mirana.IUIVisicooler;
}

class VisicoolerNuevoTable extends React.Component<IProps, IState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    @lazyInject(TYPES.REDUX_STORE)
    public reduxStore: Store<MiranaState>;

    constructor(props) {
        super(props);
        this.state = {
            openGeoModal: false,
            modalOpen: false,
        };
    }

    private buscarModelosActivos = async () => {
        const response = await this.apiClient.filtrarVisicoolerModelos(this.props.fuerzaVentaId, VisicoolerModeloEstado.ACTIVO);
        this.setState({modelosResponse: response ? response.modelos : []});
    };

    private handleGeoClick = (visicooler: mirana.IUIVisicooler) => {
        this.setState({selectedCliente: visicooler});
        this.toggleGeoModal();
    };

    private handleAsignarClick = (cliente: mirana.IUIVisicooler) => {
        this.setState({
            selectedCliente: cliente,
        });
        this.buscarModelosActivos();
        this.toggleModal();
    };

    private toggleModal = () => {
        this.reduxStore.dispatch(reset('visicooler_nuevo_form'));
        this.setState({
            modalOpen: !this.state.modalOpen
        });
    };

    private toggleGeoModal = () => {
        this.setState({
            openGeoModal: !this.state.openGeoModal
        });
    };

    private get rows() {
        const content: any[] = [];
        if (this.props.data && this.props.data.visicoolers) {
            this.props.data.visicoolers.forEach((visicooler, idx) => {
                content.push(
                    <tr key={idx}>
                        <td>{visicooler.mesa}</td>
                        <td className={'center-col'}>{visicooler.ruta}</td>
                        <td className={'center-col'}>{visicooler.diaVisita}</td>
                        <td>{visicooler.clienteId}</td>
                        <td>{visicooler.clienteRazonSocial}</td>
                        <td>{visicooler.giro}</td>
                        <td>{visicooler.direccion}</td>
                        <td className={'center-col'}>{visicooler.avanceCuota}</td>
                        <td>
                            <UncontrolledDropdown>
                                <DropdownToggle className='icon context-button' outline={true}>
                                    <SettingsIcon/>
                                </DropdownToggle>
                                <DropdownMenu className='dropdown__menu'>
                                    <DropdownItem onClick={() => this.handleGeoClick(visicooler)}>Ver
                                        Mapa</DropdownItem>
                                    <DropdownItem onClick={() => this.handleAsignarClick(visicooler)}>Asignar
                                        Visicooler</DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </td>
                    </tr>
                )
            });
        }
        return content;
    }

    private submitAsignacion = async (values) => {
        try {
            await this.apiClient.asignarVisicooler(values.clienteId, values.modelo.value, values.fuerzaVentaId);
            const newData = {...this.props.data} as any;
            const index = newData.visicoolers.findIndex(el => el.clienteId === values.clienteId);
            newData.visicoolers.splice(index, 1);
            this.props.actualizarData(newData);
            this.reduxStore.dispatch(success('Notificación', 'Asignación realizada correctamente'));
        } catch (ex) {
            this.reduxStore.dispatch(error('Error', 'Hubo un error al realizar la asignación'));
        } finally {
            this.toggleModal();
        }
    };

    public render() {
        return (
            <>
                <Table striped={true} className='table--bordered' responsive={true}>
                    <thead>
                    <tr>
                        <th>Mesa</th>
                        <th className={'center-col'}>Ruta</th>
                        <th className={'center-col'}>Visita</th>
                        <th>Código</th>
                        <th>Razón Social</th>
                        <th>Giro</th>
                        <th>Dirección</th>
                        <th className={'center-col'}>Venta</th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody>
                    {this.rows}
                    </tbody>
                </Table>
                {this.props.data ? <Paginacion numFound={this.props.data.numFound} pageSize={this.props.data.pageSize}
                                               page={this.props.data.page}
                                               handleClick={this.props.handlePagination}/> : null}
                <GeoModal isOpen={this.state.openGeoModal} toggle={this.toggleGeoModal}
                          data={this.state.selectedCliente}/>
                <VisicoolerNuevoModal onSubmit={this.submitAsignacion} toggle={this.toggleModal}
                                      cliente={this.state.selectedCliente}
                                      modelos={this.state.modelosResponse}
                                      isOpen={this.state.modalOpen}/>
            </>
        );
    }
}

export default VisicoolerNuevoTable;


// WEBPACK FOOTER //
// ./src/components/pages/visicooler/nuevo/visicooler-nuevo-table.tsx